import React, { useEffect, useRef } from "react";

/**
 * Single shared tooltip driven by [data-tip] attributes via event delegation,
 * exactly like the standalone design. Tip content is produced exclusively by
 * our formatters, never from user input.
 */
export const ChartTooltip: React.FC = () => {
    const tipRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const tip = tipRef.current;
        if (tip === null) return undefined;

        const onOver = (event: MouseEvent) => {
            if (!(event.target instanceof Element)) return;
            const el = event.target.closest("[data-tip]");
            if (el === null) return;
            tip.innerHTML = el.getAttribute("data-tip") ?? "";
            tip.style.opacity = "1";
        };
        const onMove = (event: MouseEvent) => {
            if (tip.style.opacity === "0") return;
            tip.style.left = `${event.clientX}px`;
            tip.style.top = `${event.clientY}px`;
        };
        const onOut = (event: MouseEvent) => {
            if (event.target instanceof Element && event.target.closest("[data-tip]") !== null) {
                tip.style.opacity = "0";
            }
        };

        document.addEventListener("mouseover", onOver);
        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseout", onOut);
        return () => {
            document.removeEventListener("mouseover", onOver);
            document.removeEventListener("mousemove", onMove);
            document.removeEventListener("mouseout", onOut);
        };
    }, []);

    return <div ref={tipRef} className="investors-tip" style={{ opacity: 0 }} />;
};
